export default "__VITE_ASSET__e3288204__"